import styled from "styled-components";

interface StyledOpenFilterProps {
    isOpen: boolean;
}

const StyledCloseFilter = styled.div<StyledOpenFilterProps>`
    background: #f0f2f2;
    border-radius: ${({ isOpen }) => (isOpen ? "8px 8px 0 0" : "8px")};
    height: 74px;
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover svg,
    &:hover h3 {
        fill: #8a0538;
        transition: 0.5s;
        color: #8a0538;
    }
    &:focus {
        outline: none;
    }

    .active svg {
        transform: rotate(180deg);
        transition: transform 0.5s;
        fill: #8a0538;
    }
`;

const StyledFilterHead = styled.div`
    border: none;
    margin: 0 24px;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const StyledFilterTitle = styled.h3<StyledOpenFilterProps>`
    color: ${({ isOpen }) => (isOpen ? "#8a0538" : "#404040")};
    font-size: 16px;
    margin: 0;
`;

const StyledOpenFilter = styled.div<StyledOpenFilterProps>`
    margin: 0;
    background: #f0f2f2;
    width: 100%;
    border-radius: 0 0 8px 8px;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
`;

const StyledHr = styled.hr<{ margin?: string }>`
    margin: ${({ margin }) => (margin ? `${margin}px` : 0)};
    color: #404040;
`;

const StyledFilterData = styled.div`
    padding: 20px;
    background: #fff;
    border-radius: 8px;
`;

const StyledFilterCell = styled.div`
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledActionsFilterContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 15px;
    width: 100%;
    max-width: 416px;
`;

const StyledButtonFilterContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export {
    StyledCloseFilter,
    StyledFilterTitle,
    StyledFilterHead,
    StyledOpenFilter,
    StyledHr,
    StyledFilterData,
    StyledFilterCell,
    StyledActionsFilterContainer,
    StyledButtonFilterContainer,
};
